import { render, staticRenderFns } from "./MainSideMenuItem.vue?vue&type=template&id=066ab007&scoped=true"
import script from "./MainSideMenuItem.vue?vue&type=script&lang=js"
export * from "./MainSideMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ab007",
  null
  
)

export default component.exports